__turbopack_context__.v({
  "featured": "HeaderLink-module__MF4fka__featured",
  "featuredSelected": "HeaderLink-module__MF4fka__featuredSelected",
  "root": "HeaderLink-module__MF4fka__root",
  "selected": "HeaderLink-module__MF4fka__selected",
});
